import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  GetQuotationClientRequest,
  GetQuotationClientResponse,
} from '../../../@types/GetQuotation'
import { api } from '../../../Services/API'
import { useGetQuotationStore } from '../../../Stores/useGetQuotationStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: GetQuotationClientRequest) => {
  const response = await api.post<GetQuotationClientResponse>(
    API_ROUTES.getQuotation,
    payload,
  )

  return response.data
}

export const useGetQuotation = () => {
  const { handleErrorRequest } = useErrorRequest()
  const { setGetQuotation } = useGetQuotationStore()
  return useMutation({
    mutationFn: (payload: GetQuotationClientRequest) => request(payload!),
    onSuccess(data) {
      setGetQuotation(data)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
